import DeploymentFlagCollection from './model';
import FLAGS from '../../backbone-unorganized/shared/deployment_flags/flags';

export const DeploymentFlagProvider = {
    collection: null,
    initialize: function (options = {}) {
        const { flags = FLAGS, tests = false } = options;
        this.collection = new DeploymentFlagCollection(flags, {
            tests
        });

        return new Promise((resolve) => {
            this.collection.fetch({
                success: resolve,
                error: resolve
            });
        });
    },

    get_flag: function (flagName) {
        if (!this.collection) {
            throw new Error('Please make sure `initialize` method was called');
        }
        return this.collection.get_flag(flagName);
    }
};
